import { createStyles } from "@material-ui/core";
import theme from "../../../themes";

/**
 * Shared styles used by both CreateMemberPerk and UpdateMemberPerk.
 * File-specific styles should be defined in the respective component files.
 */
export const sharedPerkFormStyles = createStyles({
    root: {
        background: theme.palette.primary.main,
        minHeight: "100vh",
        overflowX: "hidden",
    },
    header: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "20px 40px",
        gap: "6px",
        background: theme.palette.primary.main,
        [theme.breakpoints.down("sm")]: {
            padding: "20px 16px",
        },
    },
    headerTopRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
    },
    pageTitle: {

        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "32px",
        lineHeight: "150%",
        display: "flex",
        alignItems: "center",
        color: "white",
        margin: 0,
        [theme.breakpoints.down("sm")]: {
            fontSize: "22px",
            display: "block",
        },
    },
    pageSubtitle: {

        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "150%",
        display: "flex",
        alignItems: "center",
        color: "rgba(255, 255, 255, 0.9)",
        margin: 0,
        [theme.breakpoints.down("sm")]: {
            fontSize: "16px",
            lineHeight: "1.55",
            display: "block",
        },
    },
    contentContainer: {
        padding: "0 40px 20px 40px",
        background: theme.palette.primary.main,
        [theme.breakpoints.down("sm")]: {
            padding: "0 12px 16px",
        },
    },
    contentCard: {
        background: "#FFFFFF",
        borderRadius: "20px",
        padding: "20px 41px 30px",
        width: "100%",
        minHeight: "806px",
        [theme.breakpoints.down("sm")]: {
            padding: "16px 14px 24px",
            borderRadius: "16px",
            minHeight: "unset",
        },
    },
    formFrame: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "flex-start",
        padding: "40px 51px 49px",
        gap: "10px",
        width: "900px",
        maxWidth: "100%",
        background: "#FFFFFF",
        border: "0.7px solid #888888",
        borderRadius: "31px",
        [theme.breakpoints.down("sm")]: {
            padding: "20px 14px 24px",
            borderRadius: "16px",
        },
    },
    form: {
        width: "798px",
        maxWidth: "100%",
    },
    fieldContainer: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        padding: "0px",
        gap: "4px",
        marginBottom: "30px",
        width: "100%",
    },
    fieldLabelRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        padding: "0px",
        width: "100%",
    },
    fieldLabel: {

        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "18px",
        letterSpacing: "0",
        color: "#000000",
        display: "flex",
        alignItems: "center",
        [theme.breakpoints.down("sm")]: {
            fontSize: "15px",
        },
    },
    requiredAsterisk: {
        color: (theme.palette as any).delete.main,
        marginLeft: "2px",
    },
    helperText: {
        fontFamily: "Inter, sans-serif",
        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "22px",
        color: "#000000",
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        marginBottom: "10px",
        [theme.breakpoints.down("sm")]: {
            fontSize: "13px",
        },
    },
    inputField: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            backgroundColor: "#FFFFFF",
            height: "56px",
            "& fieldset": {
                borderColor: "#CCCCCC",
                borderWidth: "1px",
            },
            "&:hover fieldset": {
                borderColor: "#999999",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#000000",
                borderWidth: "2px",
            },
            "&.MuiOutlinedInput-multiline": {
                height: "auto",
                minHeight: "180px",
                alignItems: "flex-start",
            },
        },
        "& .MuiInputBase-input": {
            padding: "16px",

            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
            color: "#333333",
        },
        "& .MuiInputBase-inputMultiline": {
            padding: "16px",
        },
    },
    inputFieldError: {
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: (theme.palette as any).delete.main,
                borderWidth: "2px",
            },
        },
    },
    errorContainer: {
        display: "flex",
        alignItems: "center",
        marginTop: "8px",
    },
    errorBadge: {
        background: "#F88585",
        border: `1px solid ${(theme.palette as any).delete.main}`,
        borderRadius: "4px",
        padding: "4px 12px",

        fontWeight: 500,
        fontSize: "14px",
        lineHeight: "200%",
        color: "#FFFFFF",
    },
    charCounter: {

        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "14px",
        lineHeight: "24px",
        textAlign: "right",
        color: "#454B58",
        marginTop: "8px",
    },
    twoColumnRadioGroup: {
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "23px 32px",
        marginTop: "12px",
        [theme.breakpoints.down("sm")]: {
            gridTemplateColumns: "1fr",
        },
    },
    radioGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        marginTop: "12px",
    },
    radioLabel: {
        margin: 0,
        marginLeft: "0px",
        alignItems: "flex-start",
        "& .MuiRadio-root": {
            padding: "0px",
            marginRight: "16px",
            width: "24px",
            height: "24px",
            color: "#CCCCCC",
            "& .MuiSvgIcon-root": {
                fontSize: "24px",
            },
        },
        "& .MuiRadio-colorPrimary.Mui-checked": {
            color: theme.palette.primary.main,
        },
        "& .MuiTypography-root": {
            fontFamily: "Noto Sans, sans-serif",
            fontStyle: "normal",
            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
            color: theme.palette.text.secondary,
        },
    },
    radioLabelWithIcon: {
        display: "flex",
        alignItems: "center",
        gap: "8px",
    },
    horizontalRadioGroup: {
        display: "flex",
        flexDirection: "row",
        gap: "25px",
        marginTop: "12px",
        flexWrap: "wrap",
    },
    privatePerkCard: {
        marginTop: "30px",
        padding: "34px 35px 30px 35px",
        border: `2px solid ${theme.palette.primary.main}`,
        borderRadius: "12px",
        background: "#FFFFFF",
        position: "relative",
    },
    privatePerkCardHeader: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: "30px",
        padding: "12px 26px",
        display: "inline-block",
        position: "absolute",
        top: "-30px",
        left: "30px",
    },
    privatePerkCardTitle: {

        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        color: "#FFFFFF",
        margin: 0,
    },
    howToSetUpBox: {
        marginTop: "0px",
    },
    howToSetUpTitle: {

        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "30px",
        lineHeight: "1.3",
        color: theme.palette.primary.main,
        marginBottom: "20px",
    },
    howToSetUpText: {

        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "18px",
        lineHeight: "24px",
        color: theme.palette.text.primary,
        marginBottom: "16px",
    },
    howToSetUpList: {
        margin: "0 0 20px 0",
        paddingLeft: "20px",
        "& li": {

            fontStyle: "normal",
            fontWeight: 500,
            fontSize: "18px",
            lineHeight: "24px",
            color: theme.palette.text.primary,
            marginBottom: "8px",
        },
        "& li ul": {
            marginTop: "8px",
            listStyleType: "disc",
            "& li": {

                fontWeight: 500,
                fontSize: "18px",
                lineHeight: "24px",
                color: theme.palette.text.primary,
            },
        },
    },
    csvButtonsContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "12px",
        alignItems: "flex-start",
        marginTop: "20px",
        marginBottom: "25px",
    },
    importCsvButton: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "15px 20px",
        gap: "10px",
        background: theme.palette.primary.main,
        borderRadius: "12px",
        border: "none",
        cursor: "pointer",

        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "16px",
        lineHeight: "150%",
        color: "#FFFFFF",
    },
    downloadLinkButton: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "15px 20px",
        gap: "10px",
        background: "transparent",
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: "12px",
        cursor: "pointer",

        fontStyle: "normal",
        fontWeight: 500,
        fontSize: "18px",
        lineHeight: "24px",
        color: theme.palette.primary.main,
        textDecoration: "none",
        "&:hover": {
            backgroundColor: "rgba(225, 167, 49, 0.05)",
        },
    },
    emailInputContainer: {
        marginTop: "25px",
    },
    emailInputLabel: {

        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "18px",
        letterSpacing: "0",
        color: "#000000",
        marginBottom: "12px",
    },
    emailInputWrapper: {
        border: "1px solid #24272C",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
        minHeight: "95px",
        maxHeight: "150px",
        overflowY: "auto" as const,
        overflowX: "hidden" as const,
        padding: "8px",
        "&:focus-within": {
            borderColor: theme.palette.primary.main,
            borderWidth: "2px",
            padding: "7px",
        },
    },
    emailInputField: {
        width: "100%",
        "& .MuiOutlinedInput-root": {
            padding: "0 !important",
            flexWrap: "wrap" as const,
            alignItems: "flex-start",
            gap: "4px",
            "& fieldset": {
                border: "none",
            },
        },
        "& .MuiAutocomplete-endAdornment": {
            display: "none",
        },
        "& .MuiInputBase-input": {

            fontWeight: 400,
            fontSize: "16px",
            lineHeight: "24px",
            color: "#333333",
            minWidth: "60px !important",
            flex: "1 0 auto",
            padding: "4px 0 !important",
        },
    },
    emailChipsContainer: {
        display: "flex",
        flexWrap: "wrap",
        gap: "10px",
        padding: "16px",
        marginTop: "12px",
    },
    emailChip: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        padding: "0px 16px",
        gap: "8px",
        height: "29px",
        background: "rgba(225, 167, 49, 0.13)",
        border: `1px solid ${theme.palette.primary.main}`,
        borderRadius: "10px",

        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "24px",
        color: "#333333",
    },
    emailChipClose: {
        cursor: "pointer",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: theme.palette.primary.main,
        "&:hover": {
            opacity: 0.8,
        },
    },
    noteContainer: {
        borderRadius: "12px",
        background: "#000000",
        border: "1px solid #FFFFFF",
        padding: "23px 17px",
        marginTop: "20px",
    },
    noteBox: {
        backgroundColor: "transparent",
        borderLeft: "none",
        borderRadius: "0",
        padding: "0",
        marginTop: "0",
    },
    noteText: {

        fontStyle: "normal",
        fontWeight: 700,
        fontSize: "20px",
        lineHeight: "20px",
        color: "#FFFFFF",
        margin: 0,
        textTransform: "uppercase" as const,
        "& strong": {
            color: "#FFFFFF",
            fontWeight: 700,
        },
    },
    noteSubText: {

        fontWeight: 400,
        fontSize: "18px",
        color: "#FFFFFF",
        marginTop: "12px",
        lineHeight: "24px",
        textTransform: "none" as const,
        "& strong": {
            fontWeight: 700,
        },
    },
    switchSection: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        gap: "4px",
        marginBottom: "30px",
    },
    switchRow: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
    },
    switchLabelContainer: {
        flex: 1,
    },
    switchLabel: {

        fontStyle: "normal",
        fontWeight: 600,
        fontSize: "18px",
        lineHeight: "18px",
        letterSpacing: "0",
        color: "#000000",
        marginBottom: "4px",
    },
    switchHelperText: {

        fontStyle: "normal",
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "18px",
        color: "#000000",
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        marginBottom: "10px",
    },
    customSwitch: {
        width: "69px",
        height: "34px",
        padding: "0px",
        "& .MuiSwitch-switchBase": {
            padding: "5px",
            color: theme.palette.text.secondary,
        },
        "& .MuiSwitch-switchBase.Mui-checked": {
            color: theme.palette.primary.main,
            transform: "translateX(35px)",
        },
        "& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track": {
            backgroundColor: "rgba(225, 167, 49, 0.13)",
            border: `0.5px solid ${theme.palette.primary.main}`,
        },
        "& .MuiSwitch-track": {
            backgroundColor: "#FFFFFF",
            border: "0.5px solid #888888",
            borderRadius: "14.2px",
            opacity: 1,
        },
        "& .MuiSwitch-thumb": {
            width: "24px",
            height: "24px",
            boxShadow: "none",
            backgroundImage: `url(${require("../../../images/checkbox-uncheck.jpeg").default})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        },
        "& .MuiSwitch-switchBase.Mui-checked .MuiSwitch-thumb": {
            backgroundImage: `url(${require("../../../images/checkbox-check.jpeg").default})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
        },
    },
    collapsibleContent: {
        marginTop: "8px",
        paddingLeft: "10px",
    },
    daysContainer: {
        display: "flex",
        justifyContent: "flex-start",
        gap: "8px",
        flexWrap: "wrap",
        border: "1px solid #CCCCCC",
        borderRadius: "12px",
        padding: "15px 20px",
        backgroundColor: "#FFFFFF",
    },
    dayChip: {
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        minWidth: "50px",
        padding: "4px",
        "& .MuiCheckbox-root": {
            padding: "4px",
            color: "#CCCCCC",
        },
        "& .MuiCheckbox-colorPrimary.Mui-checked": {
            color: theme.palette.primary.main,
        },
        "& .MuiCheckbox-root .MuiSvgIcon-root": {
            fontSize: "22px",
        },
        "& .MuiTypography-root": {

            fontSize: "18px",
            fontWeight: 600,
            lineHeight: "18px",
            letterSpacing: "0",
            marginTop: "4px",
            color: "#000000",
        },
    },
    dateRangeContainer: {
        display: "flex",
        gap: "20px",
        marginTop: "20px",
        [theme.breakpoints.down("sm")]: {
            flexDirection: "column",
        },
    },
    dateField: {
        flex: 1,
        display: "flex",
        flexDirection: "column",
        gap: "8px",
        minWidth: 0,
    },
    dateFieldLabel: {

        fontWeight: 500,
        fontSize: "14px",
        color: "#333333",
        textAlign: "center" as const,
    },
    dateInputWrapper: {
        display: "flex",
        alignItems: "center",
        border: "1px solid #D0D0D0",
        borderRadius: "8px",
        padding: "14px 16px",
        height: "50px",
        boxSizing: "border-box" as const,
        cursor: "pointer",
        background: "#FFFFFF",
        position: "relative" as const,
        gap: "8px",
        "&:hover": {
            borderColor: "#BDBDBD",
        },
    },
    dateInputText: {
        flex: 1,

        fontSize: "14px",
        color: "#333333",
        userSelect: "none" as const,
    },
    dateInputPlaceholder: {
        flex: 1,

        fontSize: "14px",
        color: "#AAAAAA",
        userSelect: "none" as const,
    },
    dateNativeInput: {
        position: "absolute" as const,
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        opacity: 0,
        cursor: "pointer",
        border: "none",
        background: "transparent",
        zIndex: 1,
    },
    whereToRedeemSection: {
        marginTop: "20px",
    },
    notificationInfo: {
        background: "#FFF9E6",
        padding: "12px 16px",
        borderRadius: "8px",
        fontSize: "13px",
        color: "#856404",
        marginTop: "15px",
        lineHeight: "1.5",
    },
    tooltipIcon: {
        marginLeft: "8px",
    },
    section: {
        marginBottom: "35px",
    },
    errorLine: {
        display: "none",
    },
    redeemErrorText: {
        color: "#E53935",
        fontSize: "12px",
        marginTop: "4px",
        fontWeight: 500,
    },
});
